import React, { FC, PropsWithChildren, ReactNode } from 'react'
import styles from './formElements.module.scss'
import classNames from 'classnames'
import { handleScreenReaderEnter } from 'lib/screenReader'

type FormCheckboxProps = {
  checked?: boolean
  name: string
  onClick?: (ev: React.SyntheticEvent<HTMLElement>) => void
  readOnly?: boolean
  size?: 'small' | 'large'
  value?: string | number
  customLabelStyle?: string
  disabled?: boolean
}

const FormCheckbox: FC<PropsWithChildren<FormCheckboxProps>> = (props) => {
  const {
    checked,
    children,
    name,
    onClick,
    readOnly,
    size = 'small',
    value,
    customLabelStyle = '',
    disabled,
  } = props
  return (
    <label
      data-readonly={!!readOnly}
      className={classNames(styles.checkbox, {
        [styles.checkboxLarge]: size === 'large',
        [customLabelStyle]: customLabelStyle !== '',
      })}
      data-type='checkbox'
      tabIndex={0} // we want to focus in the full label and not in the <input />
      onKeyDown={(ev) => handleScreenReaderEnter(ev) && onClick?.()}
    >
      <input
        aria-checked={checked}
        checked={!!checked}
        name={name}
        onChange={() => {} /* React Warning - when no Function */}
        onClick={onClick}
        readOnly={!!readOnly}
        type='checkbox'
        value={value}
        tabIndex={-1} // we want to focus in the full label and not in the <input />
        disabled={disabled}
      />

      <span className={styles.icon} data-type='square-icon' aria-hidden='true'>
        {checked && <span className={styles.checkMark} data-checked={!!checked} />}
      </span>

      {children || ''}
    </label>
  )
}

export default FormCheckbox
